import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ApiCall } from '../../EnvConfig/env_config';
import { decreaseItemQuantity, increaseItemQuantity, removeFromCart, setCartModal } from '../../features/addToCartSlice';
import ModalData from './Modal';

function Cart({ carttoggle }) {
    const dispatch = useDispatch()
    const { cart } = useSelector(state => state.addToCartDetails)
    const [simDetails, setSimDetails] = useState([])
    const navigate = useNavigate()
    const [detailsModal, setDetailsModal] = useState(false)
    const [modalDetails, setModaldetails] = useState({
        NetworkID: '',
        planId: ""
    })
    const authEmail = localStorage.getItem('emailID')
    const authLoginToken = localStorage.getItem('loginToken')
    const authLoginUserCode = localStorage.getItem('loginUserCode')
    const authenticated = authEmail !== null && authLoginToken !== null && authLoginUserCode !== null;
    const url = new URL(window.location.href);
    const pathName = url.pathname;
    const [newSimOrAddOnPlan, setNewSimOrAddOnPlan] = useState([]);

    const deleteCartItem = (planID) => {
        dispatch(removeFromCart(planID))
    }
    const handleSimTypeChange = async(simType, index) => {

        if (simType === 'topUp') {
            await GetQRCodeDetails()
        }
        
        const updatedPlans = [...newSimOrAddOnPlan];
        updatedPlans[index] = {
            ...updatedPlans[index],
            newSim: simType === "newSim" ?  true : false,
            topUpRecharge: simType === "topUp" ? true : false,
            simNumber: ''
        };
        setNewSimOrAddOnPlan(updatedPlans);
    }
    const handleCheckOut = async () => {
        const updatedCart = cart?.map((item, index) => ({
            ...item,
            simOptions: newSimOrAddOnPlan[index]
        }));
        const allSimOptionsDefined = updatedCart.every(item => item.simOptions !== undefined);

        if (!allSimOptionsDefined) {
            toast.error("Please choose sim option");
            return; 
        }
        await localStorage.setItem('cartProduct', JSON.stringify(updatedCart));
        dispatch(setCartModal(false))
        if (pathName === "/checkout") {
            window.location.reload()
        }
        if (authenticated) {
            navigate("/checkout")
        } else {
            navigate("/authentication")
        }
    }

    const GetQRCodeDetails = async () => {
        let request = {
            Emailid: authEmail,
        };
        try {
            const response = await ApiCall(`/api/Web/GetQRCodeDetails`, request);
            if (response.status === 'SUCCESS') {
                setSimDetails(response.simDetail)
            } else if (response.status === 'ERROR') {
                setSimDetails([])
              //  toast.error(response.message);
            }
        } catch (error) {
            toast.error('There was a problem with the server, Please try again later');
        }
    };

    useEffect(() => {
        if (cart) {
            const initialPlans = cart?.map(() => ({
                newSim: true,
                topUpRecharge: false,
                simNumber: ''
            }));
            setNewSimOrAddOnPlan(initialPlans);
        }
    }, [cart, dispatch]);

    useEffect(() => {
        if (authenticated) {
            GetQRCodeDetails()
        }
    }, [authenticated, carttoggle])

    return (
        <>
            <div className={`cart_dropdown ${carttoggle ? 'slideIn' : ''} `} >
                <h6 className='light-bg br-12 d-flex justify-content-between p-3'>Cart <i style={{ cursor: 'pointer' }} onClick={() => dispatch(setCartModal(false))} className="bi bi-x-lg"></i></h6>
                {cart && cart?.length ? (
                    <>
                        <div className="position-relative cart_scroll">
                            {cart?.map((item, index) => (
                                <div key={index} className="cart_items border-bottom mx-2 ms-3 py-3">
                                    <div className="d-flex align-items-start gap-3">
                                        <div>
                                            {
                                                item.countryFlagURL && 
                                            <img style={{ height: "40px", width: "60px", objectFit: "cover" }} src={item.countryFlagURL} alt='contry' />
                                            }
                                        </div>
                                        <div className="cart_product_name">
                                            <h6 className='m-0'> {item?.coverage}</h6>
                                            <p // onClick={(e) => showDetailsModal(e, item.networkID, item.planID)}
                                            >
                                                {item?.planName ? item.planName.substring(0, 20) : ''}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="mt-2">
                                        <div className="d-flex justify-content-between">
                                            {
                                                item?.discountPrice === '' ?
                                                    <div className="cart_item_price fw-bold primary-text fs-5">
                                                        {item?.price}
                                                    </div>
                                                    :
                                                    <div className='d-flex align-items-center gap-2' ><div className="cart_item_price fw-bold primary-text fs-5">
                                                        {item?.discountPrice}
                                                    </div> <small class="text-danger text-decoration-line-through">{item?.price}</small></div>

                                            }
                                            
                                            <div>
                                                <button
                                                    className="light-bg qntiy-button border-0 px-3"
                                                    onClick={() => {
                                                        if (item?.quantity <= 1) {
                                                            toast.error("minimum 1 sim required to buy")
                                                            return
                                                        }
                                                        dispatch(decreaseItemQuantity(item.planID))
                                                    }}
                                                //style={{ cursor: "not-allowed" }}
                                                >
                                                    -
                                                </button>
                                                <span className="px-2">{item?.quantity}</span>
                                                {/*<input type="text" placeholder='1' />*/}
                                                <button
                                                    onClick={() => dispatch(increaseItemQuantity(item.planID))}
                                                    className="border-0 light-bg px-3 qntiy-button"
                                                // style={{ cursor: "not-allowed" }}
                                                >
                                                    +
                                                </button>
                                                <button
                                                    className="text-danger ms-2 border-0 bg-white"
                                                    onClick={async () => {
                                                        await deleteCartItem(item?.planID)
                                                        toast.success(
                                                            "Data packages has been removed successfully!"
                                                        );
                                                    }}
                                                >
                                                    <i className="bi bi-trash3"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <fieldset>
                                            <legend>Sim type : </legend>
                                            <div className="sim_selection">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="form-check">
                                                        <input
                                                            onChange={() => handleSimTypeChange('newSim', index)}
                                                            className="form-check-input pointer"
                                                            type="radio"
                                                            name={`flexRadioDefault${index}`}
                                                            id={`flexRadioDefault1-${index}`}
                                                            value="newSim"
                                                            checked={newSimOrAddOnPlan[index]?.newSim}
                                                        />
                                                        <label className="form-check-label pointer" htmlFor={`flexRadioDefault1-${index}`}>
                                                            New Sim
                                                        </label>
                                                    </div>
                                                    {
                                                        (authenticated && simDetails.length !== 0) && <div className="form-check">
                                                            <input
                                                                onChange={() => handleSimTypeChange('topUp', index)}
                                                                checked={newSimOrAddOnPlan[index]?.topUpRecharge === true}
                                                                className="form-check-input pointer"
                                                                type="radio"
                                                                name={`flexRadioDefault${index}`}
                                                                id={`flexRadioDefault2-${index}`}
                                                                value="topUpRecharge"
                                                            />
                                                            <label className="form-check-label pointer" htmlFor={`flexRadioDefault2-${index}`}>
                                                                Top Up
                                                            </label>
                                                        </div>
                                                    }

                                                </div>
                                                {
                                                    newSimOrAddOnPlan[index]?.topUpRecharge && (
                                                        <select
                                                            onChange={(e) => {
                                                                const updatedPlans = [...newSimOrAddOnPlan];
                                                                updatedPlans[index] = {
                                                                    ...updatedPlans[index],
                                                                    simNumber: e.target.value
                                                                };
                                                                setNewSimOrAddOnPlan(updatedPlans);
                                                            }}
                                                            className='form-select border-0 py-1'
                                                            value={newSimOrAddOnPlan[index]?.simNumber || ''}
                                                        >
                                                            <option value={``}>--choose your sim--</option>
                                                            {
                                                                simDetails?.map((detail, detailIndex) => (
                                                                    <option key={detailIndex} value={`${detail.iccid}`}>
                                                                        {detail.iccid + '-' + detail.coverage}
                                                                    </option>
                                                                ))
                                                            }
                                                        </select>
                                                    )
                                                }
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <button
                            onClick={(e) => handleCheckOut(e)}
                            className="mybtn secondary-bg text-dark w-100 mt-3 text-center checkout_button"
                        >
                            Checkout
                        </button>
                    </>)
                    :
                    <div className="px-3 text-center">
                        <svg
                            viewBox="656 573 264 182"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                            <rect
                                id="bg-line"
                                stroke="none"
                                fillOpacity={0.2}
                                fill="#FFE100"
                                fillRule="evenodd"
                                x={656}
                                y={624}
                                width={206}
                                height={38}
                                rx={19}
                            />
                            <rect
                                id="bg-line"
                                stroke="none"
                                fillOpacity={0.2}
                                fill="#FFE100"
                                fillRule="evenodd"
                                x={692}
                                y={665}
                                width={192}
                                height={29}
                                rx={14.5}
                            />
                            <rect
                                id="bg-line"
                                stroke="none"
                                fillOpacity={0.2}
                                fill="#FFE100"
                                fillRule="evenodd"
                                x={678}
                                y={696}
                                width={192}
                                height={33}
                                rx={16.5}
                            />
                            <g
                                id="shopping-bag"
                                stroke="none"
                                strokeWidth={1}
                                fill="none"
                                fillRule="evenodd"
                                transform="translate(721.000000, 630.000000)"
                            >
                                <polygon
                                    id="Fill-10"
                                    fill="#FFA800"
                                    points="4 29 120 29 120 0 4 0"
                                />
                                <polygon
                                    id="Fill-14"
                                    fill="#FFE100"
                                    points="120 29 120 0 115.75 0 103 12.4285714 115.75 29"
                                />
                                <polygon
                                    id="Fill-15"
                                    fill="#FFE100"
                                    points="4 29 4 0 8.25 0 21 12.4285714 8.25 29"
                                />
                                <polygon
                                    id="Fill-33"
                                    fill="#FFA800"
                                    points="110 112 121.573723 109.059187 122 29 110 29"
                                />
                                <polygon
                                    id="Fill-35"
                                    fillOpacity={0.5}
                                    fill="#FFFFFF"
                                    points="2 107.846154 10 112 10 31 2 31"
                                />
                                <path
                                    d="M107.709596,112 L15.2883462,112 C11.2635,112 8,108.70905 8,104.648275 L8,29 L115,29 L115,104.648275 C115,108.70905 111.7365,112 107.709596,112"
                                    id="Fill-36"
                                    fill="#FFE100"
                                />
                                <path
                                    d="M122,97.4615385 L122,104.230231 C122,108.521154 118.534483,112 114.257931,112 L9.74206897,112 C5.46551724,112 2,108.521154 2,104.230231 L2,58"
                                    id="Stroke-4916"
                                    stroke="#000000"
                                    strokeWidth={3}
                                    strokeLinecap="round"
                                />
                                <polyline
                                    id="Stroke-4917"
                                    stroke="#000000"
                                    strokeWidth={3}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    points="2 41.5 2 29 122 29 122 79"
                                />
                                <path
                                    d="M4,50 C4,51.104 3.104,52 2,52 C0.896,52 0,51.104 0,50 C0,48.896 0.896,48 2,48 C3.104,48 4,48.896 4,50"
                                    id="Fill-4918"
                                    fill="#000000"
                                />
                                <path
                                    d="M122,87 L122,89"
                                    id="Stroke-4919"
                                    stroke="#000000"
                                    strokeWidth={3}
                                    strokeLinecap="round"
                                />
                                <polygon
                                    id="Stroke-4922"
                                    stroke="#000000"
                                    strokeWidth={3}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    points="4 29 120 29 120 0 4 0"
                                />
                                <path
                                    d="M87,46 L87,58.3333333 C87,71.9 75.75,83 62,83 L62,83 C48.25,83 37,71.9 37,58.3333333 L37,46"
                                    id="Stroke-4923"
                                    stroke="#000000"
                                    strokeWidth={3}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M31,45 C31,41.686 33.686,39 37,39 C40.314,39 43,41.686 43,45"
                                    id="Stroke-4924"
                                    stroke="#000000"
                                    strokeWidth={3}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M81,45 C81,41.686 83.686,39 87,39 C90.314,39 93,41.686 93,45"
                                    id="Stroke-4925"
                                    stroke="#000000"
                                    strokeWidth={3}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M8,0 L20,12"
                                    id="Stroke-4928"
                                    stroke="#000000"
                                    strokeWidth={3}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M20,12 L8,29"
                                    id="Stroke-4929"
                                    stroke="#000000"
                                    strokeWidth={3}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M20,12 L20,29"
                                    id="Stroke-4930"
                                    stroke="#000000"
                                    strokeWidth={3}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M115,0 L103,12"
                                    id="Stroke-4931"
                                    stroke="#000000"
                                    strokeWidth={3}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M103,12 L115,29"
                                    id="Stroke-4932"
                                    stroke="#000000"
                                    strokeWidth={3}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M103,12 L103,29"
                                    id="Stroke-4933"
                                    stroke="#000000"
                                    strokeWidth={3}
                                    strokeLinecap="round"
                                />
                            </g>
                            <g
                                id="glow"
                                stroke="none"
                                strokeWidth={1}
                                fill="none"
                                fillRule="evenodd"
                                transform="translate(768.000000, 615.000000)"
                            >
                                <rect
                                    id="Rectangle-2"
                                    fill="#000000"
                                    x={14}
                                    y={0}
                                    width={2}
                                    height={9}
                                    rx={1}
                                />
                                <rect
                                    fill="#000000"
                                    transform="translate(7.601883, 6.142354) rotate(-12.000000) translate(-7.601883, -6.142354) "
                                    x={6.60188267}
                                    y={3.14235449}
                                    width={2}
                                    height={6}
                                    rx={1}
                                />
                                <rect
                                    fill="#000000"
                                    transform="translate(1.540235, 7.782080) rotate(-25.000000) translate(-1.540235, -7.782080) "
                                    x={0.54023518}
                                    y={6.28207994}
                                    width={2}
                                    height={3}
                                    rx={1}
                                />
                                <rect
                                    fill="#000000"
                                    transform="translate(29.540235, 7.782080) scale(-1, 1) rotate(-25.000000) translate(-29.540235, -7.782080) "
                                    x={28.5402352}
                                    y={6.28207994}
                                    width={2}
                                    height={3}
                                    rx={1}
                                />
                                <rect
                                    fill="#000000"
                                    transform="translate(22.601883, 6.142354) scale(-1, 1) rotate(-12.000000) translate(-22.601883, -6.142354) "
                                    x={21.6018827}
                                    y={3.14235449}
                                    width={2}
                                    height={6}
                                    rx={1}
                                />
                            </g>
                            <polygon
                                id="plus"
                                stroke="none"
                                fill="#7DBFEB"
                                fillRule="evenodd"
                                points="689.681239 597.614697 689.681239 596 690.771974 596 690.771974 597.614697 692.408077 597.614697 692.408077 598.691161 690.771974 598.691161 690.771974 600.350404 689.681239 600.350404 689.681239 598.691161 688 598.691161 688 597.614697"
                            />
                            <polygon
                                id="plus"
                                stroke="none"
                                fill="#EEE332"
                                fillRule="evenodd"
                                points="913.288398 701.226961 913.288398 699 914.773039 699 914.773039 701.226961 917 701.226961 917 702.711602 914.773039 702.711602 914.773039 705 913.288398 705 913.288398 702.711602 911 702.711602 911 701.226961"
                            />
                            <polygon
                                id="plus"
                                stroke="none"
                                fill="#FFA800"
                                fillRule="evenodd"
                                points="662.288398 736.226961 662.288398 734 663.773039 734 663.773039 736.226961 666 736.226961 666 737.711602 663.773039 737.711602 663.773039 740 662.288398 740 662.288398 737.711602 660 737.711602 660 736.226961"
                            />
                            <circle
                                id="oval"
                                stroke="none"
                                fill="#A5D6D3"
                                fillRule="evenodd"
                                cx={699.5}
                                cy={579.5}
                                r={1.5}
                            />
                            <circle
                                id="oval"
                                stroke="none"
                                fill="#CFC94E"
                                fillRule="evenodd"
                                cx={712.5}
                                cy={617.5}
                                r={1.5}
                            />
                            <circle
                                id="oval"
                                stroke="none"
                                fill="#8CC8C8"
                                fillRule="evenodd"
                                cx={692.5}
                                cy={738.5}
                                r={1.5}
                            />
                            <circle
                                id="oval"
                                stroke="none"
                                fill="#3EC08D"
                                fillRule="evenodd"
                                cx={884.5}
                                cy={657.5}
                                r={1.5}
                            />
                            <circle
                                id="oval"
                                stroke="none"
                                fill="#66739F"
                                fillRule="evenodd"
                                cx={918.5}
                                cy={681.5}
                                r={1.5}
                            />
                            <circle
                                id="oval"
                                stroke="none"
                                fill="#C48C47"
                                fillRule="evenodd"
                                cx={903.5}
                                cy={723.5}
                                r={1.5}
                            />
                            <circle
                                id="oval"
                                stroke="none"
                                fill="#A24C65"
                                fillRule="evenodd"
                                cx={760.5}
                                cy={587.5}
                                r={1.5}
                            />
                            <circle
                                id="oval"
                                stroke="#66739F"
                                strokeWidth={2}
                                fill="none"
                                cx={745}
                                cy={603}
                                r={3}
                            />
                            <circle
                                id="oval"
                                stroke="#EFB549"
                                strokeWidth={2}
                                fill="none"
                                cx={716}
                                cy={597}
                                r={3}
                            />
                            <circle
                                id="oval"
                                stroke="#FFE100"
                                strokeWidth={2}
                                fill="none"
                                cx={681}
                                cy={751}
                                r={3}
                            />
                            <circle
                                id="oval"
                                stroke="#3CBC83"
                                strokeWidth={2}
                                fill="none"
                                cx={896}
                                cy={680}
                                r={3}
                            />
                            <polygon
                                id="diamond"
                                stroke="#C46F82"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                                points="886 705 889 708 886 711 883 708"
                            />
                            <path
                                d="M736,577 C737.65825,577 739,578.34175 739,580 C739,578.34175 740.34175,577 742,577 C740.34175,577 739,575.65825 739,574 C739,575.65825 737.65825,577 736,577 Z"
                                id="bubble-rounded"
                                stroke="#3CBC83"
                                strokeWidth={1}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                            />
                        </svg>
                        <p>You haven't added products to the cart!</p>
                        <Link
                            to="/"
                            className="mybtn_border d-block text-dark w-100"
                            onClick={() => dispatch(setCartModal(false))}
                        >
                            Shop Now!
                        </Link>
                    </div>
                }
            </div>
            <div className={`cart_overlay ${carttoggle ? 'd-block' : 'd-none'}`} onClick={() => dispatch(setCartModal(false))}></div>
            {detailsModal && <ModalData onClose={() => setDetailsModal(false)} detailsModal={detailsModal} NetworkID={modalDetails.NetworkID} planId={modalDetails.planId} />}
        </>
    )
}

export default Cart
